import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'lineEndingDisplay'
})
export class LineEndingDisplayPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    var result:string='';
    if(value=='LF') result='Line Feed (LF)';
    else if(value=='CR') result='Carriage Return (CR)';
    else if(value=='CRLF') result='Carriage Return + Line Feed (CR + LF)';
    return result;
  }
}